/**
 * Defines the Permissions types
 */
export enum PermissionsType {
  crud = 'crud',
  crudAttr = 'crudAttr',
  action = 'action',
  custom = 'custom',
}

export enum SupportedAppCodes {
  XDM = 'XDM',
  XBOF = 'XBOF',
  XPOS = 'XPOS',
  XPRT = 'XPRT',
  XVI = 'xvi',
  XEA = 'xea',
}
